"use strict";

var _Object$keys = require("@babel/runtime-corejs2/core-js/object/keys");
var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs2/core-js/object/get-own-property-symbols");
var _Object$getOwnPropertyDescriptor2 = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor");
var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptors");
var _Object$defineProperties = require("@babel/runtime-corejs2/core-js/object/define-properties");
var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _promise = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/promise"));
var _apply = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/reflect/apply"));
var _getOwnPropertyDescriptor = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));
var _applyDecoratedDescriptor2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/applyDecoratedDescriptor"));
var _isArray2 = _interopRequireDefault(require("lodash/isArray"));
var _common = require("@webex/common");
var _webexCore = require("@webex/webex-core");
var _userUuidBatcher = _interopRequireDefault(require("./user-uuid-batcher"));
var _userUuidStore = _interopRequireDefault(require("./user-uuid-store"));
var _dec, _dec2, _dec3, _dec4, _obj;
function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return _Object$getOwnPropertyDescriptor2(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor2(source, key)); }); } return target; }
/**
 * @class
 */
var User = _webexCore.WebexPlugin.extend((_dec = (0, _webexCore.waitForValue)('@'), _dec2 = (0, _common.oneFlight)({
  keyFactory: function keyFactory(email, options) {
    return email + String(options && options.create);
  }
}), _dec3 = (0, _webexCore.persist)('@'), _dec4 = (0, _common.deprecated)('Use User#verify()'), (_obj = {
  namespace: 'User',
  children: {
    batcher: _userUuidBatcher.default
  },
  props: {
    /**
     * Indicates if the current user is known to have a password.
     * @instance
     * @memberof User
     * @type {boolean}
     */
    hasPassword: {
      default: false,
      type: 'boolean'
    }
  },
  session: {
    store: {
      default: function _default() {
        return new _userUuidStore.default();
      },
      type: 'any'
    }
  },
  /**
   * Activates a Webex user account and exchanges for user token.
   * @instance
   * @memberof User
   * @param {Object} options
   * @param {Object} options.confirmationCode (required -- optional if verification token is provided)
   * @param {Object} options.id (required -- optional if verification token is provided)
   * @param {Object} options.verificationToken (required -- optional if uuid and verification token provided)
   * @param {Object} options.email (required with verificationToken for Federation/global user)
   * @returns {Promise} Resolves with a userSession
   */
  activate: function activate() {
    var _this = this;
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    if (!(options.verificationToken || options.confirmationCode && options.id)) {
      return _promise.default.reject(new Error('either options.verificationToken is required or both options.confirmationCode and options.id are required'));
    }
    options.scope = this.webex.config.credentials.scope;

    // if we have options.email and options.verificationToken
    // and Federation flag is enabled, flag that we need to
    // lookup user's CI.
    var activateOptions = _objectSpread({}, options);
    delete activateOptions.email;
    return this.request({
      uri: this.webex.config.credentials.activationUrl,
      method: 'POST',
      body: activateOptions,
      auth: {
        user: this.webex.config.credentials.client_id,
        pass: this.webex.config.credentials.client_secret,
        sendImmediately: true
      }
    }).then(function (res) {
      _this.webex.credentials.set({
        supertoken: res.body.tokenData
      });
      return res.body;
    });
  },
  /**
   * Converts a user-identifying object to a uuid, perhaps by doing a network
   * lookup
   * @param {string|Object} user
   * @param {Object} options
   * @param {boolean} options.create if true, ensures the return UUID refers to
   * an existing user (rather than creating one deterministically based on email
   * address), even if that user must be created
   * @returns {Promise<string>}
   */
  asUUID: function asUUID(user, options) {
    var _this2 = this;
    if (!user) {
      return _promise.default.reject(new Error('`user` is required'));
    }
    if ((0, _isArray2.default)(user)) {
      return _promise.default.all(user.map(function (u) {
        return _this2.asUUID(u, options);
      }));
    }
    var id = this._extractUUID(user);
    if (!(options && options.force) && _common.patterns.uuid.test(id)) {
      return _promise.default.resolve(id);
    }
    var email = this._extractEmailAddress(user);
    if (!_common.patterns.email.test(email)) {
      return _promise.default.reject(new Error('Provided user object does not appear to identify a user'));
    }
    return this.getUUID(email, options);
  },
  /**
   * Requests a uuid from the api
   * @param {string} email
   * @param {Object} options
   * @param {boolean} options.create
   * @returns {Promise<string>}
   */
  fetchUUID: function fetchUUID(email, options) {
    var _this3 = this;
    return this.batcher.request({
      email: email,
      create: options && options.create
    }).then(function (user) {
      return _this3.recordUUID(_objectSpread({
        emailAddress: email
      }, user)).then(function () {
        return user.id;
      });
    });
  },
  /**
   * Generates One Time Password.
   * @instance
   * @param {Object} options
   * @param {string} options.email
   * @param {string} options.id
   * @returns {Promise}
   */
  generateOTP: function generateOTP() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    if (!(options.email || options.id)) {
      return _promise.default.reject(new Error('One of `options.email` or `options.id` is required'));
    }
    return this.request({
      uri: this.webex.config.credentials.generateOtpUrl,
      method: 'POST',
      body: options,
      auth: {
        user: this.webex.config.credentials.client_id,
        pass: this.webex.config.credentials.client_secret
      }
    }).then(function (res) {
      return res.body;
    });
  },
  /**
   * Fetches details about the current user
   * @returns {Promise<Object>}
   */
  get: function get() {
    var _this4 = this;
    return this.request({
      service: 'conversation',
      resource: 'users'
    }).then(function (res) {
      return res.body;
    }).then((0, _common.tap)(function (user) {
      return _this4.recordUUID({
        id: user.id,
        // CI endpoints don't use the same user format as actors, so, email may
        // be in one of a few fields
        emailAddress: user.email || user.emailAddress
      });
    }));
  },
  getUUID: function getUUID(email, options) {
    var _this5 = this;
    return this.store.getByEmail(email).then(function (user) {
      if (options && options.create && !user.userExists) {
        return _promise.default.reject(new Error('User for specified email cannot be confirmed to exist'));
      }
      if (!user.id) {
        return _promise.default.reject(new Error('No id recorded for specified user'));
      }
      return user.id;
    }).catch(function () {
      return _this5.fetchUUID(email, options);
    });
  },
  initialize: function initialize() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return (0, _apply.default)(_webexCore.WebexPlugin.prototype.initialize, this, args);
  },
  /**
   * Caches the uuid for the specified email address
   * @param {Object} user
   * @param {string} user.id
   * @param {string} user.emailAddress
   * @returns {Promise}
   */
  recordUUID: function recordUUID(user) {
    if (!user) {
      return _promise.default.reject(new Error('`user` is required'));
    }
    if (!user.id) {
      return _promise.default.reject(new Error('`user.id` is required'));
    }
    if (!_common.patterns.uuid.test(user.id)) {
      return _promise.default.reject(new Error('`user.id` must be a uuid'));
    }
    if (!user.emailAddress) {
      return _promise.default.reject(new Error('`user.emailAddress` is required'));
    }
    if (!_common.patterns.email.test(user.emailAddress)) {
      return _promise.default.reject(new Error('`user.emailAddress` must be an email address'));
    }
    return this.store.add(user);
  },
  register: function register() {
    return this.verify.apply(this, arguments);
  },
  /**
   * Updates a user with webex.
   * @param {Object} body
   * @private
   * @returns {Promise} Resolves with a response from PATCH request
   */
  _setUser: function _setUser(body) {
    var _this6 = this;
    return this.webex.credentials.getUserToken().then(function (token) {
      return _this6.request({
        uri: "".concat(_this6.webex.config.credentials.setPasswordUrl, "/").concat(_this6.webex.internal.device.userId),
        method: 'PATCH',
        headers: {
          authorization: token.toString()
        },
        body: body
      });
    });
  },
  /**
   * Updates a user's password with webex.
   * @instance
   * @memberof User
   * @param {Object} options
   * @param {string} options.password (required)
   * @param {string} options.email (required when federation enabled)
   * @returns {Promise} Resolves with complete user object containing new password
   */
  setPassword: function setPassword(options) {
    var _this7 = this;
    options = options || {};
    if (!options.password) {
      return _promise.default.reject(new Error('`options.password` is required'));
    }
    return this._setUser({
      schemas: ['urn:scim:schemas:core:1.0', 'urn:scim:schemas:extension:cisco:commonidentity:1.0'],
      password: options.password
    }).then(function (res) {
      _this7.hasPassword = true;
      return res.body;
    });
  },
  /**
   * Updates a user's name with webex.
   * @instance
   * @memberof User
   * @param {string} givenName
   * @param {string} familyName
   * @param {string} displayName
   * @returns {Promise<Object>}
   */
  updateName: function updateName() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      givenName = _ref.givenName,
      familyName = _ref.familyName,
      displayName = _ref.displayName;
    if (!(givenName || familyName || displayName)) {
      return _promise.default.reject(new Error('One of `givenName` and `familyName` or `displayName` is required'));
    }
    return this._setUser({
      schemas: ['urn:scim:schemas:core:1.0', 'urn:scim:schemas:extension:cisco:commonidentity:1.0'],
      name: {
        givenName: givenName,
        familyName: familyName
      },
      displayName: displayName
    }).then(function (res) {
      return res.body;
    });
  },
  /**
   * Updates the current user's display name
   * @param {Object} options
   * @param {string} options.displayName
   * @returns {Promise<Object>}
   */
  update: function update(options) {
    options = options || {};
    if (!options.displayName) {
      return _promise.default.reject(new Error('`options.displayName` is required'));
    }
    return this.request({
      method: 'PATCH',
      service: 'conversation',
      resource: 'users/user',
      body: options
    }).then(function (res) {
      return res.body;
    });
  },
  /**
   * Validated One Time Password.
   * @instance
   * @param {Object} options
   * @param {string} options.email
   * @param {string} options.id
   * @param {string} options.oneTimePassword
   * @returns {Promise}
   */
  validateOTP: function validateOTP() {
    var _this8 = this;
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    if (!(options.email || options.id) || !options.oneTimePassword) {
      return _promise.default.reject(new Error('One of `options.email` or `options.id` and `options.oneTimePassword` are required'));
    }
    options.scope = this.webex.config.credentials.scope;
    return this.request({
      uri: this.webex.config.credentials.validateOtpUrl,
      method: 'POST',
      body: options,
      auth: {
        user: this.webex.config.credentials.client_id,
        pass: this.webex.config.credentials.client_secret
      }
    }).then(function (res) {
      _this8.webex.credentials.set({
        supertoken: res.body.tokenData
      });
      return res.body;
    });
  },
  /**
   * Determines if the specified user needs to signup or can signin.
   * Triggers activation email if client credentials are used
   * @param {Object} options
   * @param {string} options.email (required)
   * @param {string} options.reqId required if need to check email status
   * @param {string} options.preloginId
   * @returns {Promise<Object>}
   */
  verify: function verify(options) {
    var _this9 = this;
    options = _objectSpread(_objectSpread({}, this.config.verifyDefaults), options);
    var _options = options,
      email = _options.email;
    if (!email) {
      return _promise.default.reject(new Error('`options.email` is required'));
    }
    return this.webex.internal.services.collectPreauthCatalog({
      email: email
    }).then(function () {
      return _this9.webex.credentials.getUserToken();
    }).catch(function () {
      return _this9.webex.credentials.getClientToken();
    }).then(function (token) {
      return _this9.request({
        service: 'atlas',
        resource: 'users/activations',
        method: 'POST',
        headers: {
          authorization: token.toString(),
          'x-prelogin-userid': options.preloginId
        },
        body: options,
        shouldRefreshAccessToken: false
      });
    }).then(function (res) {
      if (res.body.hasPassword || res.body.sso) {
        _this9.hasPassword = true;
      }
      return res.body;
    });
  },
  /**
   * If the passed-in lookupCI is true, retrieve the user's
   * CI from Atlas and return the URL's via a Promise.
   * Otherwise, return current CI in config via a Promise.
   * Useful in a Promise chain to retrieve the CI based on
   * conditions like Federation enabled, and suppresses sending
   * an additional email to the user, since this is just a
   * look-up.
   * @param {string} email (required)
   * @param {boolean} lookupCI (required)
   * @returns {Promise<Object>}
   */
  getUserCI: function getUserCI(email, lookupCI) {
    if (lookupCI) {
      // call verify first to get the user's CI, but suppress sending another email
      var verifyOptions = {
        email: email,
        suppressEmail: true
      };
      return this.verify(verifyOptions).then(function (res) {
        return _promise.default.resolve(res.userEntities);
      });
    }
    return _promise.default.resolve({
      idBrokerUrl: this.webex.config.credentials.idbroker.url,
      identityUrl: this.webex.config.credentials.identity.url
    });
  },
  /**
   * Extracts the uuid from a user identifying object
   * @param {string|Object} user
   * @private
   * @returns {string}
   */
  _extractUUID: function _extractUUID(user) {
    return user.entryUUID || user.id || user;
  },
  /**
   * Extracts the email address from a user identifying object
   * @param {string|Object} user
   * @private
   * @returns {string}
   */
  _extractEmailAddress: function _extractEmailAddress(user) {
    return user.email || user.emailAddress || user.entryEmail || user;
  },
  version: "2.59.8"
}, ((0, _applyDecoratedDescriptor2.default)(_obj, "activate", [_dec], (0, _getOwnPropertyDescriptor.default)(_obj, "activate"), _obj), (0, _applyDecoratedDescriptor2.default)(_obj, "getUUID", [_dec2], (0, _getOwnPropertyDescriptor.default)(_obj, "getUUID"), _obj), (0, _applyDecoratedDescriptor2.default)(_obj, "initialize", [_dec3], (0, _getOwnPropertyDescriptor.default)(_obj, "initialize"), _obj), (0, _applyDecoratedDescriptor2.default)(_obj, "register", [_dec4], (0, _getOwnPropertyDescriptor.default)(_obj, "register"), _obj)), _obj)));
var _default2 = User;
exports.default = _default2;
//# sourceMappingURL=user.js.map
